module.exports = __webpack_public_path__ + "img/fail.216ca038.png";